// extracted by mini-css-extract-plugin
export var activeDot = "_36-c";
export var buttonContainer = "_36-9";
export var channelButton = "_36-a";
export var clickable = "_36-d";
export var content = "_36-0";
export var contentFull = "_36-2";
export var contentThird = "_36-1";
export var contentWrapper = "_36-7";
export var description = "_36-5";
export var heightShort = "_36-f";
export var image = "_36-3";
export var imageContainer = "_36-4";
export var selectButton = "_36-e";
export var spinnerContainer = "_36-b";
export var titleContent = "_36-8";
export var titleWrapper = "_36-6";